module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/31.5c6d36e0.png";